import type { SocialLink } from '@kkf/design'

/** Content for the project-details page. */
export const PROJECT_DETAIL = {
  /** Placeholder content: the same image three times. */
  gallery: [
    '/assets/img/project-details-img-1.jpg',
    '/assets/img/project-details-img-1.jpg',
    '/assets/img/project-details-img-1.jpg',
  ],
  title: 'Child trouble & care',
  descr:
    'Netus lorem rutrum arcu dignissim at sit morbi phasellus nascetur eget potenti vestibulum is cras. Tempor nonummy metus lobortis. Sociis velit etiam, dapibus.Lectus ve pellentesque a cras posuere tempor facilisi habitant lectus rutrum pede quisque hendrerit mauris ad to elementum fringilla facilisi volutpat fusce pharetra.',
  body:
    'Netus lorem rutrum arcu dignissim at sit morbi phasellus nascetur eget potenti vestibulum is cras. Tempor nonummy metus lobortis. Sociis velit etiam, dapibus.Lectus ve pellentesque a cras posuere tempor facilisi habitant lectus rutrum pede . Netus lorem rutrum arcu dignissim at sit morbi phasellus nascetur eget potenti vestibulum is cras.',
  challengeTitle: 'Challenge & Solution ',
  challengeBody:
    'Future, as it seeks to lead the industry in technological innovation and sustainable building practices to deliver long-lasting value for its clients. Netus lorem rutrum arcu dignissim at sit morbi nascetur eget potenti vestibulum is cras. Tempor nonummy metus lobortis. Sociis velit etiam, dapibus.Lepellentesque a cras posuere tempor facilisi habitant lectus rutrum pede .',
  resultTitle: 'Final Result',
  /**
   * The trailing `./p>` is placeholder copy that renders as literal text. It looks like
   * a broken closing tag and is preserved deliberately; replace it with real copy rather
   * than "fixing" it in place.
   */
  resultBody:
    'For almost 50 years Leighton Asia, one of the region’s largest and most respected construc companies, has been progressively building for a better future by leveraging international expertise with local intelligence. In that time Leighton./p>',
  info: [
    { key: 'CATEGORY', value: 'Business, Marketing' },
    { key: 'AUTHOR', value: 'Athena Jones' },
    { key: 'TAGS', value: 'Data Masters' },
    { key: 'COST', value: 'USD 1,50,499' },
    { key: 'DATE', value: '25 February, 2024' },
  ],
  socials: [
    { icon: 'facebook', href: '#', label: 'Facebook' },
    { icon: 'twitter', href: '#', label: 'Twitter' },
    { icon: 'linkedin-big-logo', href: '#', label: 'LinkedIn' },
    { icon: 'youtube', href: '#', label: 'YouTube' },
  ] satisfies SocialLink[],
}
